module.exports = __webpack_public_path__ + "static/media/012ty@4x.ab519caa.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/012ty@4x.png
// module id = 417
// module chunks = 0 1